import pick from 'lodash/pick'
import { EMOJI, SEQUENCE_STEPS, STEP_FAILED_INDEX } from '../../utils/constants'
import { getApiCallSequenceSteps, getRandomInt } from '../../utils/misc'
import { HTTP_RESPONSE_CODE_200, USER_INITIAL_STATE } from './constants'
import {
  IGetPayloadData,
  IReducerAction,
  IReducerItem,
  IReducerItemContent,
  IReducersAPICombined,
  IResourceNames,
  ISequenceTypes
} from './interface'

export const createInitialStates = (names: Array<string>, initialState: IReducerItemContent) =>
  names.reduce((object: IReducerItem, item: string) => {
    object[item] = { ...initialState }
    return object
  }, {})

export const createResourceNames = (names: Array<string>): IResourceNames =>
  names.reduce((object: IResourceNames, item: string) => {
    object[item] = item
    return object
  }, {})

export const createSequenceTypes = (names: Array<string>): ISequenceTypes =>
  names.reduce((object: IResourceNames, item: string) => {
    object = { ...object, ...getApiCallSequenceSteps(item) }
    return object
  }, {})

export const getErrorData = (payload: object) => pick(payload, ['message', 'response'])

export const getPayloadData = ({ data, status }: IGetPayloadData) => {
  const WAS_SUCCESSFUL = Boolean(status >= HTTP_RESPONSE_CODE_200.min && status <= HTTP_RESPONSE_CODE_200.max)
  return [Array.isArray(data) ? data : { ...data }, { response: { status: status, wasSuccessful: WAS_SUCCESSFUL } }]
}

export const getUserFromStateOrLocalStorage = (LOCAL_STORAGE_APP_STATE: any, LOCAL_STORAGE_USER: string) =>
  LOCAL_STORAGE_APP_STATE[LOCAL_STORAGE_USER] || { ...USER_INITIAL_STATE }

export const reducerAPILogger = (
  actionAndPayload: IReducerAction,
  reducersAPICombined: IReducersAPICombined,
  state: object
): IReducersAPICombined => {
  const { data: payload, type: action } = actionAndPayload
  const EMOJI_TITLE = '⚡️ '
  const IS_ERROR: boolean = action.includes(SEQUENCE_STEPS[STEP_FAILED_INDEX].toString())
  const NEXT_STATE: any = reducersAPICombined[action](state, payload)
  const PAYLOAD_EMOJI: string = IS_ERROR ? EMOJI.events[0] : EMOJI.fruits[getRandomInt(EMOJI.fruits.length)]
  const PAYLOAD_LABEL: string = payload ? `, Payload: ${PAYLOAD_EMOJI}` : ''
  const PREV_STATE: any = { ...state }
  const STYLES = {
    next: 'color: #00a1af',
    prev: 'color: #aeafb1',
    title: IS_ERROR ? 'color: red' : 'color: #e40595'
  }
  const TITLE_CONTENT = `%c${EMOJI_TITLE}${action}${PAYLOAD_LABEL}`
  let payloadData: object | string = payload ? payload : ''
  payloadData = IS_ERROR ? getErrorData(payload) : payload

  if (payload) {
    console.groupCollapsed(TITLE_CONTENT, STYLES.title, payloadData)
  } else {
    console.groupCollapsed(TITLE_CONTENT, STYLES.title)
  }
  console.log('%cPrev:', STYLES.prev, PREV_STATE)
  console.log(`%cNext:`, STYLES.next, NEXT_STATE)
  console.groupEnd()

  return NEXT_STATE
}
